import type { ActionButtonProps } from '../../components/commandActions/types'
import { AnnotationCommand } from './AnnotationCommand'

export const LegalEntityAnnotationCommand = (props: ActionButtonProps) => (
  <AnnotationCommand {...props} festinaComponent="legalEntity" />
)
